import React, { useState, useEffect } from 'react';
import './HeroSection.css';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { translations } from '../utils/translations';

const HeroSection = () => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const t = translations[selectedLang.code || 'en'] || translations.en;
  const [activeDot, setActiveDot] = useState(0);
  const slides = [
    { image: "/images/banners/banner2.webp" },
    { image: "/images/banners/banner4.webp" },
    { image: "/images/banners/banner8.png" },
    { image: "/images/banners/banner1.webp" },
    { image: "/images/banners/banner3.webp" },
    { image: "/images/banners/banner7.png" },
    { image: "/images/banners/banner5.webp" },
    { image: "/images/banners/banner6.jpeg" },

  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setActiveDot((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(slideInterval);
  }, [slides.length, activeDot]);

  const currentSlide = slides[activeDot];

  const handleScrollToProducts = (e) => {
    e.preventDefault();
    const element = document.getElementById('explore-products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="hero-section-wrapper">
      <div className="hero-section-container">
        {/* Right Main Banner & Carousel Area */}
        <div className="hero-main-area">
          {/* Main Carousel Banner */}
          <div className="hero-carousel">


            <div className="carousel-slide banner-only-slide">
              <img src={currentSlide.image} alt={`Banner ${activeDot + 1}`} className="slide-banner-img" />
            </div>



            {/* Carousel Dots */}
            <div className="carousel-dots">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${activeDot === index ? 'active' : ''}`}
                  onClick={() => setActiveDot(index)}
                ></span>
              ))}
            </div>
          </div>

          {/* Bottom 3 Promo Cards Grid */}
          <div className="promo-grid">
            {/* Promo Card 1 */}
            <div className="promo-card card-audio">
              <div className="promo-info">
                <span className="promo-subtitle">{t.newAudioCollection}</span>
                <h3 className="promo-title">{t.premiumOverEarHeadphones}</h3>
                <a href="#explore-products" onClick={handleScrollToProducts} className="promo-btn">{t.featureToday}</a>
              </div>
              <img src="/images/promo_headphones.png" alt="Premium Headphones" className="promo-img" />
            </div>

            {/* Promo Card 2 */}
            <div className="promo-card card-xiaomi">
              <div className="promo-info">
                <span className="promo-subtitle">{t.todaySpecialPrice}</span>
                <h3 className="promo-title">{t.xiaomiRedmiNote13}</h3>
                <a href="#explore-products" onClick={handleScrollToProducts} className="promo-btn-link">{t.shopNow} <span className="arrow">→</span></a>
              </div>
              <img src="/images/promo_xiaomi.png" alt="Xiaomi Smartphone" className="promo-img" />
            </div>

            {/* Promo Card 3 */}
            <div className="promo-card card-wearables">
              <div className="promo-info">
                <span className="promo-subtitle">{t.smartWearables}</span>
                <h3 className="promo-title">{t.trendingSmartwatches}</h3>
                <a href="#explore-products" onClick={handleScrollToProducts} className="promo-btn-link">{t.shopNow} <span className="arrow">→</span></a>
              </div>
              <img src="/images/promo_smartwatch.png" alt="Smartwatches" className="promo-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
